import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import getFetchCartOptions from "../../../carts/v2/fetch/get-options";
import fetchFulfillmentOfferings from "../api-calls/fetch";
import getFulfillmentOfferingsQueryKey from "../get-query-key";

/**
 * Fetches pickup availability for a sku at a single location. This hook will handle the pickup availability preview for each item in the cart.
 * @param {Object} param
 * @param {string} param.skuId - Sku identifier, unique UUID of the sku
 * @param {string} param.productId - Product identifier
 * @param {string} param.locationType - Location type, for now it's hard coded as 'store/store_views'
 * @param {string} param.locationId - Location identifier, unique UUID of the location
 * @param {Object} param.queryClient
 * @returns {Object}
 */
var getFetchPickupOfferingOptions = function getFetchPickupOfferingOptions(_ref) {
  var skuId = _ref.skuId,
    productId = _ref.productId,
    _ref$locationType = _ref.locationType,
    locationType = _ref$locationType === void 0 ? 'store/store_views' : _ref$locationType,
    locationId = _ref.locationId,
    queryClient = _ref.queryClient;
  var offeringTypes = 'PICKUP';

  // eslint-disable-next-line @tanstack/query/exhaustive-deps
  return {
    queryKey: getFulfillmentOfferingsQueryKey({
      skuId: skuId,
      productId: productId,
      locationId: locationId,
      offeringTypes: offeringTypes,
      locationType: locationType
    }),
    queryFn: function () {
      var _queryFn = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var cart, currency;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return queryClient.fetchQuery(getFetchCartOptions({
                queryClient: queryClient
              }));
            case 1:
              cart = _context.sent;
              currency = cart.currency;
              return _context.abrupt("return", fetchFulfillmentOfferings({
                skuId: skuId,
                productId: productId,
                locationId: locationId,
                locationType: locationType,
                offeringTypes: offeringTypes,
                currency: currency
              }));
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function queryFn() {
        return _queryFn.apply(this, arguments);
      }
      return queryFn;
    }(),
    staleTime: Infinity,
    // Data never goes stale (prevents auto-refetches)
    retry: false,
    // Don't retry on initial failure
    retryOnMount: false,
    // KEY: Don't retry failed queries when new components mount
    gcTime: Infinity // Keep error/success data in cache forever
  };
};
export default getFetchPickupOfferingOptions;